import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useConfirmPayment = (consultationId) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error confirming payment");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (consultationDueId) => {
      const axiosInstance = await createAxiosInstance();
      let endpoint;

      if (consultationDueId) {
        endpoint = `${tenantVal}/consultationpayment/confirmpayment/consultationid/${consultationId}/consultationdueid/${consultationDueId}`;
      } else {
        endpoint = `${tenantVal}/consultationpayment/confirmpayment/consultationid/${consultationId}`;
      }

      const response = await axiosInstance.post(endpoint);
      return response.data;
    },
    onSuccess: () => {
      toast.success("Payment completed successfully");
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
      queryClient.invalidateQueries({ queryKey: [consultationId] });
      queryClient.invalidateQueries({ queryKey: ["consultationPaymentsDue"] });
      queryClient.invalidateQueries({ queryKey: ["consultationServices"] });
      queryClient.invalidateQueries({ queryKey: ["consultation"] });
    },
    onError: handleNetworkError,
  });
};
